import { makeAutoObservable, observable } from "mobx";
var ErrorStore = /** @class */ (function () {
    function ErrorStore() {
        Object.defineProperty(this, "message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ""
        });
        makeAutoObservable(this, {
            message: observable,
            code: observable,
        });
    }
    Object.defineProperty(ErrorStore.prototype, "showError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (value) {
            this.message = value.message;
            this.code = value.code;
        }
    });
    Object.defineProperty(ErrorStore.prototype, "clearError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.message = "";
            this.code = "";
        }
    });
    return ErrorStore;
}());
export default ErrorStore;
